import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-site px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-background-50">
                91
              </span>
              <span className="font-heading text-base font-bold text-background-50">
                {siteInfo.brand}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {siteInfo.intro}
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">内容分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.type}>
                  <Link
                    to={`/category/${cat.type}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/search?q=热门"
                  className="text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  搜索内容
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">关于本站</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  内容来源说明
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 transition-colors hover:text-accent-300"
                >
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-mail-line" />
                </span>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-time-line" />
                </span>
                {siteInfo.workingHours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.brand}. 保留所有权利。</p>
          <p>{siteInfo.copyright}</p>
        </div>
      </div>
    </footer>
  );
}